<template>
  <div class="px-2">
    <template>
      <v-tabs v-model="tabs" color="transparent">
        <v-tab
          href="#tab-1"
          active-class="white--text tab-color"
          @click="order_type_all = 1"
          >All</v-tab
        >
        <v-tab
          href="#tab-2"
          active-class="white--text tab-color"
          @click="order_type_all = 2"
        >
          Food Delivery
          <v-btn fab outline color="red" style="height: 28px; width: 28px">{{
            (order_count.we_order_status ? checkCountOrder("we") : 0) +
            (order_count.we_order_status ? checkCountOrder("fr") : 0)
          }}</v-btn>
        </v-tab>
        <v-tab
          href="#tab-3"
          active-class="white--text tab-color"
          @click="order_type_all = 3"
        >
          Messenger
          <v-btn fab outline color="red" style="height: 28px; width: 28px">{{
            order_count.me_order_status ? checkCountOrder("me") : 0
          }}</v-btn>
        </v-tab>
      </v-tabs>
    </template>
    <v-tabs-items touchless v-model="tabs" class="white elevation-1">
      <v-tab-item
        v-for="i in 3"
        :key="i"
        :value="'tab-' + i"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat style="border: 1px solid #333">
          <v-data-table
            :headers="headers"
            :items="filtersItems(order_status)"
            :loading="fetching_order"
            :rows-per-page-items="[
              25,
              50,
              100,
              { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
            ]"
          >
            <template slot="items" slot-scope="props">
              <tr style="background-color: #eeeeee">
                <td class="text-xs-left">{{ props.item.order_code }}</td>
                <td class="text-xs-left">
                  {{
                    props.item.order_customer_full_name ||
                    props.item.order_business_full_name
                  }}
                </td>
                <v-select
                  :items="statusOrderWE"
                  v-model="type[props.index]"
                  @change="changeStatus($event, props.item, props.index)"
                  item-text="name"
                  :label="checkLabel(props.item.order_status)"
                  item-value="value"
                  style="width: 130px"
                  :loading="changing_status.includes(props.item.order_id)"
                  :disabled="
                    changing_status.includes(props.item.order_id) ||
                    (order_status == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    order_status == 0 ||
                    isEditOrder
                  "
                  v-if="
                    props.item.order_type == 1 || props.item.order_type == 3
                  "
                ></v-select>
                <v-select
                  :items="statusOrderME"
                  v-model="type[props.index]"
                  @change="changeStatus($event, props.item, props.index)"
                  item-text="name"
                  :label="checkLabel(props.item.order_status)"
                  item-value="value"
                  style="width: 130px"
                  :loading="changing_status.includes(props.item.order_id)"
                  :disabled="
                    changing_status.includes(props.item.order_id) ||
                    (order_status == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    order_status == 0 ||
                    isEditOrder
                  "
                  v-if="props.item.order_type == 2"
                ></v-select>

                <td class="text-xs-center">
                  <!--  -->
                  <countdown
                    :time="
                      calTime(
                        props.item.order_time_start,
                        props.item.order_code
                      )
                    "
                  >
                    <template slot-scope="props1">
                      <div
                        :style="
                          props1.totalMilliseconds == 0 ? 'color:green;' : null
                        "
                      >
                        {{
                          NotiReadey(props1.totalMilliseconds, props.item) == 0
                            ? "Ready"
                            : amountCharTime(props1.days * 24 + props1.hours) +
                              ":" +
                              amountCharTime(props1.minutes) +
                              ":" +
                              amountCharTime(props1.seconds)
                        }}
                      </div>
                    </template>
                  </countdown>
                </td>
                <td class="text-xs-center">
                  {{ props.item.order_rider_full_name }}
                </td>
                <!-- <td class="text-xs-center">{{ props.item.order_store_name }}</td> -->
                <td class="text-xs-center">
                  {{
                    props.item.order_discount == null
                      ? null
                      : props.item.order_discount_code
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.order_net_price
                      ? parseFloat(props.item.order_net_price).toFixed(2)
                      : "0.00"
                  }}
                </td>
                <td class="text-xs-center">
                  <v-icon
                    medium
                    :color="
                      props.item.order_is_paymented != 1 ||
                      props.item.order_payment_type == 2 ||
                      props.item.order_payment_type == 5
                        ? 'green'
                        : 'red'
                    "
                    >{{
                      props.item.order_payment_type == 1
                        ? "attach_money"
                        : props.item.order_payment_type == 2
                        ? "credit_card"
                        : props.item.order_payment_type == 3
                        ? "phone_iphone"
                        : props.item.order_payment_type == 4
                        ? "currency_exchange"
                        : props.item.order_payment_type == 5
                        ? "corporate_fare"
                        : ""
                    }}</v-icon
                  >
                </td>

                <td class="text-xs-center">
                  {{
                    props.item.order_time_start == null
                      ? null
                      : props.item.order_time_start.substring(0, 10) +
                        " - " +
                        props.item.order_time_start.substring(11, 16) +
                        " น."
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.order_time_end == null
                      ? null
                      : props.item.order_time_end.substring(0, 10) +
                        " - " +
                        props.item.order_time_end.substring(11, 16) +
                        " น."
                  }}
                </td>
                <!-- <td class="justify-center layout px-0">
            <v-btn small @click="toDetail()">Details</v-btn>
                </td>-->

                <td class="justify-center layout px-0">
                  <v-tooltip
                    top
                    v-if="
                      props.item.order_type == 1 || props.item.order_type == 3
                    "
                  >
                    <v-btn
                      slot="activator"
                      small
                      icon
                      @click="toDetail(props.item.order_id)"
                    >
                      <v-icon small>{{
                        (props.item.order_status == 6 &&
                          $store.state.permission.order.edit_view != 3) ||
                        (props.item.order_status == 7 &&
                          $store.state.permission.order.edit_view != 3) ||
                        isEditOrder
                          ? "remove_red_eye"
                          : "edit"
                      }}</v-icon>
                    </v-btn>
                    <span>{{
                      (props.item.order_status == 6 &&
                        $store.state.permission.order.edit_view != 3) ||
                      (props.item.order_status == 7 &&
                        $store.state.permission.order.edit_view != 3) ||
                      isEditOrder
                        ? "View"
                        : "View/Edit"
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top v-if="props.item.order_type == 2">
                    <v-btn
                      slot="activator"
                      small
                      icon
                      @click="toMessengerDetail(props.item.order_id)"
                    >
                      <v-icon small>{{
                        (props.item.order_status == 6 &&
                          $store.state.permission.order.edit_view != 3) ||
                        (props.item.order_status == 7 &&
                          $store.state.permission.order.edit_view != 3)
                          ? "remove_red_eye"
                          : "edit"
                      }}</v-icon>
                    </v-btn>
                    <span>{{
                      (props.item.order_status == 6 &&
                        $store.state.permission.order.edit_view != 3) ||
                      (props.item.order_status == 7 &&
                        $store.state.permission.order.edit_view != 3)
                        ? "View"
                        : "View/Edit"
                    }}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <!-- <span v-if="props.item.order_status != null">
            <li v-for="(info,index) in props.item.order_store" :key="index"> {{ info.store_name }} {{ checkLabel(info.store_order_status) }} </li>
                </span>-->

                <td
                  colspan="8"
                  v-if="
                    props.item.order_store == null && props.item.order_type == 2
                  "
                >
                  <v-card flat color="transparent">
                    <v-card-text class="text-xs-left pl-0">
                      <ul>
                        <li>
                          <span style="font-weight: bold">Start</span>
                          :
                          {{
                            props.item.order_point
                              ? props.item.order_point.order_point_first
                              : ""
                          }}
                        </li>
                        <li>
                          <span style="font-weight: bold">End</span>
                          &nbsp; &nbsp; :
                          {{
                            props.item.order_point
                              ? props.item.order_point.order_point_last
                              : ""
                          }}
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </td>
                <td
                  v-if="
                    props.item.order_use_merchant === true &&
                    props.item.order_type == 1
                  "
                >
                  <v-btn
                    small
                    depressed
                    color="orange"
                    class="white--text"
                    style="border-radius: 10px"
                    >Merchant</v-btn
                  >
                </td>
                <td v-else></td>
                <td
                  v-if="
                    props.item.order_payment_method === 2 &&
                    props.item.order_type == 1
                  "
                >
                  <v-btn
                    small
                    depressed
                    color="red"
                    class="white--text"
                    style="border-radius: 10px"
                    >Pay at store</v-btn
                  >
                </td>

                <td
                  v-else-if="
                    props.item.order_payment_method === 3 &&
                    props.item.order_type == 1
                  "
                >
                  <v-btn
                    small
                    depressed
                    color="red"
                    class="white--text"
                    style="border-radius: 10px"
                    >Pay at store (Partner)</v-btn
                  >
                </td>

                <td v-else></td>
                <!-- <td
                  v-if="
                    (props.item.order_store != null &&
                      props.item.order_type == 1) ||
                      props.item.order_type == 2
                  "
                ></td> -->
                <td
                  colspan="10"
                  v-if="
                    props.item.order_store != null &&
                    (props.item.order_type == 1 || props.item.order_type == 3)
                  "
                >
                  <v-card flat color="transparent">
                    <v-card-text class="text-xs-left pl-0">
                      <ol>
                        <v-layout
                          row
                          wrap
                          v-for="(info, index) in props.item.order_store"
                          :key="index"
                        >
                          <v-flex xs2>
                            <li>{{ info.store_name }}</li>
                          </v-flex>
                          <v-flex xs4>
                            <ul style="list-style-type: none">
                              <li>
                                <div style="display: flex; align-items: center">
                                  <v-icon small class="pr-2"
                                    >new_releases</v-icon
                                  >
                                  <span>
                                    {{
                                      props.item.order_distance != null
                                        ? "Distance: " +
                                          props.item.order_distance +
                                          " m."
                                        : "ไม่ระบุระยะทาง"
                                    }}
                                  </span>
                                </div>
                                <!-- <span class="ml-2">
                                  {{
                                    info.store_order_time_end != null
                                      ? "เวลาคาดการณ์ : " +
                                        info.store_order_time_end.substring(
                                          11,
                                          16
                                        )
                                      : null
                                  }}
                                </span> -->
                              </li>
                            </ul>
                          </v-flex>
                          <!-- <v-flex xs4>
                            <span style="font-weight:bold;">AREA: </span>
                            {{ `${props.item.order_districts_name}` }}
                          </v-flex> -->
                        </v-layout>
                      </ol>
                    </v-card-text>
                  </v-card>
                </td>
              </tr>
            </template>

            <template slot="no-data"></template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import newOrderForm from "./NewOrderForm";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_status", "fetching_order"],
  components: {
    newOrderForm,
  },
  data: () => ({
    count: [],
    title: document.title,
    date1: new Date().toISOString().substr(0, 10),
    changing_status: [],
    tabs: null,
    order_type_all: 1,
    type: [],
    statusOrderME: [
      { name: "Order made", value: 1 },
      { name: "In queue", value: 2 },
      { name: "On the way", value: 5 },
      { name: "Complete", value: 6 },
    ],
    statusOrderWE: [
      { name: "Order made", value: 1 },
      { name: "In queue", value: 2 },
      { name: "Cooking", value: 3 },
      { name: "Ready to pick up", value: 4 },
      { name: "On the way", value: 5 },
      { name: "Complete", value: 6 },
    ],
    headers: [
      {
        text: "Order code",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Customer",
        value: "role",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Timer inqueue",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Rider",
        align: "center",
        value: "name",
        sortable: false,
      },
      // {
      //   text: "Store",
      //   align: "center",
      //   value: "role",
      //   sortable: false
      // },
      {
        text: "Promotion",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Total",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Payment",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "DatetimeOrder",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "DatetimeDelivery",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "role",
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapState({
      order_count: (state) => state.fetchOrderListBack.order_count,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    order_list() {
      return this.$store.state.fetchOrderListBack[
        "order_list_" + this.order_status
      ];
    },
  },
  watch: {
    order_type_all() {
      this.count = [];
      document.title = this.$store.state.fetchGeneral.title;
    },
    order_list: {
      handler: function () {
        this.count = [];
        document.title = this.$store.state.fetchGeneral.title;
        if (this.order_list.length != 0) {
          if (this.order_status != 0) {
            if (this.order_list[0].order_status != this.order_status) {
              this.$store.commit("fetchOrderListBack/getOrderList", {
                order_status_id: this.order_status,
                res_data: [],
              });
            }
          }
        }
      },
      deep: true,
    },
  },

  created() {
    if (this.$store.state.fetchGeneral.title == null) {
      this.$store.commit("fetchGeneral/getTitle", this.title);
    }

    document.title = this.$store.state.fetchGeneral.title;
    this.initialize();
  },
  methods: {
    changeTitle() {
      if (this.count.length > 0) {
        var newTitle =
          "(" + this.count.length + ") " + this.$store.state.fetchGeneral.title;
      } else {
        var newTitle = this.$store.state.fetchGeneral.title;
      }
      document.title = newTitle;
    },
    NotiReadey(time, item) {
      if (
        time == 0 &&
        item.order_status == 1 &&
        !this.count.includes(item.order_id)
      ) {
        this.count.push(item.order_id);
      }
      this.changeTitle();
      return time;
    },
    amountCharTime(time) {
      return time.toString().length >= 2
        ? time.toString()
        : "0" + time.toString();
    },

    calTime(order_time_start, code) {
      var date1 = new Date();
      var date2 = new Date(order_time_start);
      var diff = 10 * 1000 + 2 * 60 * 1000 + date2.getTime() - date1.getTime();
      var msec = diff;
      var hh = Math.floor(msec / 1000 / 60 / 60);
      msec -= hh * 1000 * 60 * 60;
      var mm = Math.floor(msec / 1000 / 60);
      msec -= mm * 1000 * 60;
      var ss = Math.floor(msec / 1000);
      msec -= ss * 1000;
      return hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000 > 0
        ? hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000
        : 0;
    },
    checkIcon(status) {
      if (status == 1) {
        return "new_releases";
      } else if (status == 2) {
        return "list_alt";
      } else if (status == 3) {
        return "room_service";
      } else if (status == 4) {
        return "pan_tool";
      } else if (status == 5) {
        return "motorcycle";
      } else if (status == 6) {
        return "check_circle";
      } else if (status == 7) {
        return "cancel";
      } else if (status == 8) {
        return "check_circle";
      } else if (status == 9) {
        return "check_circle";
      }
    },
    checkCountOrder(value) {
      if (this.order_status == 1) {
        return this.order_count[value + "_order_status"]
          .order_status_order_made;
      } else if (this.order_status == 2) {
        return this.order_count[value + "_order_status"].order_status_in_queue;
      } else if (this.order_status == 3) {
        return this.order_count[value + "_order_status"].order_status_cooking;
      } else if (this.order_status == 4) {
        return this.order_count[value + "_order_status"]
          .order_status_ready_to_pick;
      } else if (this.order_status == 5) {
        return this.order_count[value + "_order_status"]
          .order_status_on_the_way;
      } else if (this.order_status == 6) {
        return this.order_count[value + "_order_status"].order_status_complete;
      } else if (this.order_status == 7) {
        return this.order_count[value + "_order_status"].order_status_cancel;
      } else if (this.order_status == 0) {
        return this.order_count[value + "_order_status"].order_status_preorder;
      }
    },
    async changeStatus(value, item, index) {
      if (item.order_type == 1 || item.order_type == 3) {
        let send_data = {
          status: value,
          item,
        };

        this.type[index] = [];
        this.changing_status.push(item.order_id);
        await this.$store.dispatch(
          "fetchOrderListBack/changeStatus",
          send_data
        );
        let findIndex = this.changing_status.findIndex(
          (val) => val == item.order_id
        );
        this.changing_status.splice(findIndex, 1);
      } else {
        let send_data = {
          status: value,
          item,
        };
        this.type[index] = [];
        this.changing_status.push(item.order_id);
        await this.$store.dispatch(
          "fetchOrderListBack/changeStatusME",
          send_data
        );
        let findIndex = this.changing_status.findIndex(
          (val) => val == item.order_id
        );
        this.changing_status.splice(findIndex, 1);
      }
      await this.$store.dispatch("fetchOrderListBack/getCountOrder");
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status
      );
    },
    checkLabel(status) {
      if (status == 1) {
        return "Order made";
      } else if (status == 2) {
        return "In queue";
      } else if (status == 3) {
        return "Cooking";
      } else if (status == 4) {
        return "Ready to pick up";
      } else if (status == 5) {
        return "On the way";
      } else if (status == 6) {
        return "Complete";
      } else if (status == 7) {
        return "Cancel";
      } else if (status == 8) {
        return "Pending";
      } else if (status == 9) {
        return "Store approving";
      }
    },
    filtersItems(value) {
      if (this.order_type_all == 1) {
        return this.order_list;
      } else if (this.order_type_all == 2) {
        let data = [];
        for (let key in this.order_list) {
          if (
            this.order_list[key].order_type == 1 ||
            this.order_list[key].order_type == 3
          ) {
            data.push(this.order_list[key]);
          }
        }
        return data;
      } else {
        let data = [];
        for (let key in this.order_list) {
          if (this.order_list[key].order_type == 2) {
            data.push(this.order_list[key]);
          }
        }
        return data;
      }
    },
    initialize() {},
    toDetail(order_id) {
      this.$emit("setOrderID", order_id);
      this.$emit("detail", "orderDetail");
      this.$emit("hidePagename", false);
    },
    toMessengerDetail(order_id) {
      this.$emit("setOrderID", order_id);
      this.$emit("detail", "orderMessengerDetail");
      this.$emit("hidePagename", false);
    },
  },
};
</script>
<style>
.tab-color {
  background-color: black;
  border-radius: 9px 9px 0px 0px;
  font-weight: 700;
}
</style>
